import { CampaignCodeGeneratorStructure } from '../../api/types'

export interface AvailableMetric {
  metricID: string
  displayName: string
  units?: string
  description?: string
  calculation?: string[]
  setupComplete: boolean
  increasePositive: boolean
  isStandard: boolean
  isUplifterClickMetric?: boolean
}

export interface AvailableDimension {
  dateFormat?: string | null
  dimensionParameterID: string
  dimensionName: string
  dimensionOptions?: string[] | null
  helpText?: string | null
  parameterType: string
}

export interface GraphQLState {
  campaignCodeGenerator: CampaignCodeGeneratorStructure | null
  currentCompany: CurrentCompany | null
  error: string[]
  loading: string[]
}

export const initialState = {
  campaignCodeGenerator: null,
  currentCompany: null,
  error: [],
  loading: [],
}
export const keys = ['currentCompany', 'campaignCodeGenerator']

export const graphql = (
  state: GraphQLState = initialState,
  action: ReduxAction,
): GraphQLState => {
  switch (action.type) {
    case 'UPDATE_GRAPHQL_DATA': {
      const newState = {}
      const erroredKeys = [...state.error]
      const loadingKeys = [...state.loading]

      keys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(action.payload, key)) {
          // Adding support for data that comes back as an array
          if (Array.isArray(action.payload[key])) {
            newState[key] =
              state[key] === null
                ? [...action.payload[key]]
                : [...state[key], ...action.payload[key]]
          } else {
            newState[key] =
              state[key] === null
                ? { ...action.payload[key] }
                : { ...state[key], ...action.payload[key] }
          }
          const pos = erroredKeys.indexOf(key)
          if (pos !== -1) {
            erroredKeys.splice(pos, 1)
          }
          const posLoading = loadingKeys.indexOf(key)
          if (posLoading !== -1) {
            loadingKeys.splice(posLoading, 1)
          }
        }
      })

      return {
        ...state,
        ...newState,
        error: [...erroredKeys],
        loading: [...loadingKeys],
      }
    }
    case 'START_LOADING_GRAPHQL_DATA': {
      const { loading } = action.payload
      const loadingKeys = [...state.loading]
      if (loading) {
        loading.forEach((key) => {
          // keys can be added multiple times
          // this is important for multiple loads

          // if (loadingKeys.indexOf(key) === -1) {
          loadingKeys.push(key)
          // }
        })
      }
      return {
        ...state,
        loading: [...loadingKeys],
      }
    }
    case 'ERROR_GRAPHQL_DATA': {
      const { error } = action.payload
      const erroredData = {}
      const erroredKeys = [...state.error]
      const loadingKeys = [...state.loading]
      if (error) {
        error.forEach((key) => {
          erroredData[key] = Object.prototype.hasOwnProperty.call(
            initialState,
            key,
          )
            ? initialState[key]
            : null
          if (erroredKeys.indexOf(key) === -1) {
            erroredKeys.push(key)
          }
          const posLoading = loadingKeys.indexOf(key)
          if (posLoading !== -1) {
            loadingKeys.splice(posLoading, 1)
          }
        })
      }
      return {
        ...state,
        ...erroredData,
        error: [...erroredKeys],
        loading: [...loadingKeys],
      }
    }
    default:
      return state
  }
}
